import React, { useState, useEffect } from 'react';
import { Form } from "semantic-ui-react";
import { useFormik } from 'formik';
import { Level, Grade } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { initialValues, validationSchema } from "./GradeForm.form";
import { withEmptyOption } from "../../../../utils";

const levelController = new Level();
const gradeController = new Grade();

export function GradeForm(props) {

  const { onClose, onReload, grade } = props;
  const { accessToken } = useAuth();

  const [levelsOptions, setLevelsOptions] = useState([]);
  
  const formik = useFormik({
    initialValues: initialValues(grade),
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        const data = {
          levelId: formValue.levelId,
          name: formValue.name,
        };

        if (grade) {
          await gradeController.updateGrade(accessToken, grade.id, data);
        } else {
          data.status = 1;
          await gradeController.createGrade(accessToken, data);
        }
        onReload();
        onClose();
      } catch (error) {
        console.error(error);
      }
    },
  });

  useEffect(() => {
    (async () => {
      try {
        setLevelsOptions([]);
        const response = await levelController.getLevels(accessToken);
        const options = response.map((level) => ({
          value: level.id,
          text: level.name,
        }));
        setLevelsOptions(options);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [accessToken]);

  return (
    <Form onSubmit={formik.handleSubmit}>
      <Form.Select
        className="edunova-select"
        name="levelId"
        label="Nivel académico"
        placeholder="Selecciona un nivel académico"
        clearable
        options={withEmptyOption(levelsOptions, "Selecciona un nivel académico")}
        onChange={(e, { value }) =>
          formik.setFieldValue("levelId", value)
        }
        value={formik.values.levelId}
        error={formik.errors.levelId}
      />
      <Form.Input
        name="name"
        label="Nombre de grado"
        onChange={formik.handleChange}
        value={formik.values.name}
        error={formik.errors.name}
      />
      <Form.Button type="submit" primary fluid loading={formik.isSubmitting}>
        {grade ? "Actualizar grado" : "Crear grado"}
      </Form.Button>
    </Form>
  )
}
